/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';
import Backgrid from 'backgrid';

import './ButtonCell.css';
import tmplButtonCell from './ButtonCell.hbs';

const ButtonCell = Backgrid.Cell.extend({
  className: 'button-cell td-grid-cell-btn',

  events: {
    'click button': 'onClickOfButton'
  },

  render() {
    let buttonClass = 'btn-primary btn-xs';
    if (this.buttonClass) {
      buttonClass = Backgrid.callByNeed(this.buttonClass, this, this.model);
    }

    let labelClass;
    if (this.labelClass) {
      labelClass = Backgrid.callByNeed(this.labelClass, this, this.model);
    }

    let ariaLabel;
    if (this.ariaLabel) {
      ariaLabel = Backgrid.callByNeed(this.ariaLabel, this, this.model);
    }

    if (this.buttonParentClass) {
      this.$el.addClass(this.buttonParentClass);
    }

    this.$el.addClass(this.column.get('name'));

    this.$el.empty().append(
      tmplButtonCell({
        name: _.isFunction(this.name) ? this.name.bind(this) : this.name,
        labelClass,
        disabled: this.disabled,
        buttonClass,
        ariaLabel
      })
    );

    if (this.buttonAttrs) {
      this.$el.find('button').attr(this.buttonAttrs);
    }

    this.delegateEvents();
    return this;
  },

  onClickOfButton(e) {
    e.preventDefault();
    if (this.onClick && _.isFunction(this.onClick)) {
      this.onClick(e, this.model);
    }
  }
});

export default ButtonCell;
